export default __webpack_public_path__ + "static/media/machine.fbd82b09.svg";